export class Debouncer {

    private handle?: number;

    debounce(handler: TimerHandler, timeout: number): void {
        clearTimeout(this.handle);
        this.handle = setTimeout(handler, timeout);
    }

}